import React from 'react';
import { Paper, Typography } from '@mui/material';
import TicketActivitySnippet from '../tickets/TicketActivitySnippet';

/**
 * Ticket activity summary for elevated roles (wraps existing snippet).
 */
export default function TicketSummaryWidget({
  userData,
  onOpenActivity,
  onOpenTickets,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Ticket summary
      </Typography>
      <TicketActivitySnippet
        userData={userData}
        onOpenActivity={onOpenActivity}
        onOpenTickets={onOpenTickets}
      />
    </Paper>
  );
}
